module.exports = __webpack_public_path__ + "img/img_test_1980.2b8623ca.jpg";